export const InternalLoadType = {
    ProgressiveToSplatBuffer: 0,
    ProgressiveToSplatArray: 1,
    DownloadBeforeProcessing: 2
};
